module.exports = __webpack_public_path__ + "static/image/service/m/connect@3x.jpg?6b7e8bb4";